/**
 * 메뉴 레지스트리 API client — 서비스 관리 화면의 "메뉴 관리".
 * admin BFF /api/admin/menus/* (workchat Postgres admin_menu_registry).
 */
import { apiClient } from './client';

export interface MenuRow {
  id: number;
  menu_key: string;
  url: string;
  label: string;
  icon: string;
  sort_order: number;
  module_key: string | null;
  section: string;
  enabled: boolean;
  is_external: boolean;
  created_at: string;
  updated_at: string;
}

export interface MenuInput {
  menu_key?: string;
  url?: string;
  label?: string;
  icon?: string;
  sort_order?: number;
  module_key?: string | null;
  section?: string;
  enabled?: boolean;
  is_external?: boolean;
}

export async function listMenus(): Promise<MenuRow[]> {
  const { data } = await apiClient.get<{ menus: MenuRow[] }>('/admin/menus');
  return Array.isArray(data?.menus) ? data.menus : [];
}
export async function createMenu(input: MenuInput): Promise<MenuRow> {
  const { data } = await apiClient.post<MenuRow>('/admin/menus', input);
  return data;
}
export async function updateMenu(id: number, patch: MenuInput): Promise<MenuRow> {
  const { data } = await apiClient.patch<MenuRow>(`/admin/menus/${id}`, patch);
  return data;
}
export async function deleteMenu(id: number): Promise<void> {
  await apiClient.delete(`/admin/menus/${id}`);
}
